<template>
  <v-container fluid>
    <div id="signModalTop"></div>
    <template v-if="showFail">
      <v-col cols="12">
        <v-alert dense outlined type="error">
          {{ failMsg }}
        </v-alert>
      </v-col>
    </template>
    <template v-if="startSign">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Pradedamas pasirašymas
    </template>
    <template v-if="showSignType">
      <h4 class="mb-2">Pasirašymo būdas</h4>
      <v-row>
        <v-col cols="6">
          <v-card
            class="mx-auto"
            @click="setSignType('single')"
            height="100%"
            :elevation="0"
          >
            <el-tipas-icon
              icon="mdi-cellphone-key"
              :active="false"
              :type="ntrpaslaugos ? 'prasymas' : ''"
            >
            </el-tipas-icon>
            <v-card-text>
              <div>
                Mobilieji įrenginiai
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="mx-auto"
            @click="setSignType('multi')"
            height="100%"
            :elevation="0"
          >
            <el-tipas-icon
              icon="mdi-credit-card-check-outline"
              :active="false"
              :type="ntrpaslaugos ? 'prasymas' : ''"
            >
            </el-tipas-icon>
            <v-card-text>
              <div>
                USB laikmena arba kortelė ir skaitytuvas
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import bylaName from '../../mixins/bylaName'
import math from '../../mixins/math'

export default {
  name: 'ModalSign',
  props: {
    openSign: Boolean,
    unsignedBylos: {
      type: Array,
      default: () => {
        return []
      },
    },
    busena: String,
    ntrpaslaugos: { type: Boolean, default: false },
    paieskaId: { type: Number, default: null },
  },
  mixins: [bylaName, math],
  data() {
    return {
      showFail: false,
      failMsg: null,
      startSign: false,
      byla: [],
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'prasymasID',
      'prasymasTipas',
      'signType',
      'appSavitarna',
    ]),

    showSignType() {
      return this.openSign && !this.isSignType && !this.showFail
    },
    isSignType() {
      return this.signType !== null
    },
    isSingle() {
      return this.signType === 'single'
    },
    needSign() {
      return this.unsignedBylos.length > 0
    },
    isSavitarna() {
      return this.appSavitarna
    },
  },
  created() {
    if (this.openSign) {
      this.getData()
    }
  },
  watch: {
    openSign(val) {
      if (!val) {
      }
    },
  },
  methods: {
    scrollToTop() {
      document
        .getElementById('signModalTop')
        .scrollIntoView({ behavior: 'smooth' })
    },
    getData() {
      if (!this.needSign) {
        this.signDone()
        return
      }
      this.$nextTick(() => {
        this.scrollToTop()
      })

      if (this.isSignType) {
        this.initSign()
      } else {
        if (this.unsignedBylos.length === 1) {
          this.setSignType('single')
        }
      }
    },
    setSignType(signType) {
      this.$store.dispatch('signType', signType).then(this.initSign())
    },
    getReturnUrl() {
      let returnHost = this.isSavitarna
        ? process.env.VUE_APP_SAVITARNA_URL
        : process.env.VUE_APP_URL
      let returnParams = ''

      if (this.paieskaId) {
        return `${returnHost}paieska-sign/${this.paieskaId}${returnParams}`
      }

      if (this.ntrpaslaugos) {
        return `${returnHost}${
          this.isSavitarna
            ? `ntr-paslaugos/ntr-sign/${this.prasymasTipas}/`
            : `ntr-sign/`
        }${this.prasymasID}${returnParams}`
      }

      return `${returnHost}sign/${this.objektasID}${returnParams}`
    },
    getUrl() {
      if (this.paieskaId) {
        return `paieska/${this.paieskaId}/pasirasymas/inicijuoti`
      }

      if (this.ntrpaslaugos) {
        return `ntrpaslaugos/prasymas/${this.prasymasID}/pasirasymas/inicijuoti`
      }

      return `objektas/${this.objektasID}/pasirasymas/inicijuoti`
    },
    initSign() {
      this.showFail = false
      this.startSign = true

      let bylos = this.bylaToSign(
        this.isSingle ? this.unsignedBylos.slice(0, 1) : this.unsignedBylos
      )

      const returnUrl = this.getReturnUrl()
      const url = this.getUrl()

      const signData = {
        signType: this.signType,
        returnUrl: returnUrl,
        bylos: bylos,
      }

      this.$axios
        .post(url, signData)
        .then(res => {
          this.$store
            .dispatch('signTransactionID', res.data.transactionID)
            .then(this.goSign(res.data.signingUrl))
        })
        .catch(err => {
          if (err.response.status === 400) {
            this.showFail = true
            this.failMsg = err.response.data.message
            this.startSign = false
          } else {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          }
        })
    },
    returnUrl() {},
    bylaToSign(bylos) {
      return bylos.map(byla => {
        this.byla = byla
        return {
          byl_id: byla.byl_id,
          fileName: this.signFileName(this.bylaName),
        }
      })
    },
    goSign(signingUrl) {
      window.location.href = signingUrl
    },
    signDone() {
      if (this.openSign) {
        this.$emit('signDone')
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
